/**
 * Camel-style UI labels: capitalize each word.
 * "Create team" → "Create Team". Underscored codes become title case:
 * "PRIVILEGE_LEAVE" → "Privilege Leave". Short acronyms like WFH stay unchanged.
 */
export function toCamelCaseLabel(value: string): string {
  return value
    .replace(/_+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[A-Za-z0-9][^\s]*/g, word => {
      const letters = word.replace(/[^A-Za-z]/g, '');
      if (
        letters.length >= 2 &&
        letters.length <= 3 &&
        letters === letters.toUpperCase()
      ) {
        return word;
      }
      if (letters.length > 1 && letters === letters.toUpperCase()) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
}

/** Display-only formatter for leave types and similar stored codes. */
export function formatDisplayLabel(
  value: string | null | undefined,
  fallback = '',
): string {
  const trimmed = value?.trim();
  if (!trimmed) return fallback;
  return toCamelCaseLabel(trimmed);
}
